import {Component, Input} from '@angular/core';
import {IGamePlayerInputData} from "../../../interfaces/player/IGamePlayerInputData";
import {UIStateEnum} from "../../../enum/UIStateEnum";
import {FormControl, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {PlayersService} from "../../../services/players.service";
import {ErrorHandlingService} from "../../../services/error-handling.service";
import {IPaymentRefund} from "../../../interfaces/player/IPaymentRefund";
import {ColDef, GridApi, GridReadyEvent} from "ag-grid-community";
import {IPlayerPaymentTransactions} from "../../../interfaces/player/IPlayerPaymentTransactions";
import {DateService} from "../../../services/date.service";
import {MatCard, MatCardContent} from "@angular/material/card";
import {MatFormField, MatHint, MatLabel, MatSuffix} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {MatDatepicker, MatDatepickerInput, MatDatepickerToggle} from "@angular/material/datepicker";
import {MatButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {MatTooltip} from "@angular/material/tooltip";
import {AgGridAngular} from "ag-grid-angular";
import {PlayerInfoTableDefs} from "../../player-game-info/player-info-table-defs";

@Component({
  selector: 'app-manage-player-refunds',
  standalone: true,
  imports: [
    MatCard,
    MatCardContent,
    ReactiveFormsModule,
    MatFormField,
    MatHint,
    MatInput,
    MatDatepicker,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatLabel,
    MatSuffix,
    MatButton,
    MatIcon,
    MatTooltip,
    AgGridAngular
  ],
  templateUrl: './manage-player-refunds.component.html',
  styleUrl: './manage-player-refunds.component.css'
})
export class ManagePlayerRefundsComponent {

  @Input()
  public set gamePlayerData(gamePlayerDataP: IGamePlayerInputData) {
    if (gamePlayerDataP.playerId && gamePlayerDataP.game.Id) {
       this.getPlayerRefunds(gamePlayerDataP.playerId, gamePlayerDataP.game.Id);
    }
  }

  public playerRefunds: IPaymentRefund[] = [];
  public filteredRefunds: IPaymentRefund[] = [];
  public refundGridApi!: GridApi<IPaymentRefund>;
  public refundColumnDefs: ColDef[] = this.playerInfoTables.refundColumnDefs;
  public uiState: UIStateEnum = UIStateEnum.ShowData;
  public uiStateForTemplate = UIStateEnum;

  public refundSearchForm = new FormGroup({
    chargeId: new FormControl(''),
    refundId: new FormControl(''),
    refundDate: new FormControl('')
  })

  constructor(private playerService: PlayersService,
              private errorHandlingService: ErrorHandlingService,
              private dateService: DateService,
              private playerInfoTables: PlayerInfoTableDefs) {

  }

  getPlayerRefunds(playerIdP: string, gameIdP: string) {
    this.uiState = UIStateEnum.ShowLoading;
    this.playerService.getPlayerRefundsByGameId(playerIdP, gameIdP).subscribe({
      next: (refundsP) => {
        this.playerRefunds = refundsP;
        this.filteredRefunds = refundsP.sort((a, b) => new Date(a.CreatedOn).getDate() - new Date(b.CreatedOn).getDate());
        this.uiState = UIStateEnum.ShowData;
      }, error: (err) => {
        this.errorHandlingService.displayPageLevelErrorMessage(err, 'There was an issue retrieving player refunds. If the problem persists, contact a system administrator.')
      }
    });
  }

  onTransactionGridReady(params: GridReadyEvent<IPaymentRefund>) {
    this.refundGridApi = params.api;
    this.refundGridApi.sizeColumnsToFit({
      defaultMinWidth: 100,
    });
  }

  onResetClick() {
    this.refundSearchForm.reset();
    this.filteredRefunds = this.playerRefunds;
  }

  onFormSubmit() {
    if (!this.refundSearchForm.valid) {
      this.refundSearchForm.markAllAsTouched();
      return;
    }
    this.filteredRefunds = this.playerRefunds.filter((refundP) => {
      let chargeIdFilterPasses: boolean = true;
      let refundIdFilterPasses: boolean = true;
      let dateFilterPasses: boolean = true;

      if (this.refundSearchForm.value.chargeId) {
        chargeIdFilterPasses = refundP.StripeChargeId.includes(this.refundSearchForm.value.chargeId);
      }

      if (this.refundSearchForm.value.refundId) {
        refundIdFilterPasses = refundP.StripeRefundId.includes(this.refundSearchForm.value.refundId);
      }

      if (this.refundSearchForm.value.refundDate) {
        const parsedDate = new Date(this.refundSearchForm.value.refundDate);
        dateFilterPasses = this.dateService.areDatesSameDay(refundP.CreatedOn, parsedDate)
      }


      return chargeIdFilterPasses && refundIdFilterPasses && dateFilterPasses;
    })
  }
}
